import React from 'react'
import {Box,Button,FormControlLabel,Grid,MenuItem, Select, ListItem} from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const AntSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const ControllersRoleMapping = ({
  showController,
  controllerList,
  appRolesList,
  controllerRolePermissionsList,
  handleSwitchChange,
  handleAccessSelect,
  handleSaveData,
}) => {

  return (
    (showController &&
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <ListItem className='headingItemNew'>Controller</ListItem>
            {controllerList?.data?.map((controller,index) => (
              <ListItem key={index} className='actionList'><MemoryIcon /> {controller.controller_name}</ListItem>
            ))}
          </Grid>
          <Grid item sm={4} xs={12}>
            <ListItem className='headingItemNew'>Permission</ListItem>
            {controllerList?.data?.map((controller,index) => {
             let details = controllerRolePermissionsList?.data && controllerRolePermissionsList?.data?.find(per => per?.controller_id === controller.id);
              return (
                <ListItem className='permissionListButton'>
                  <FormControlLabel
                    value={index}
                    control={
                      <AntSwitch
                        key={controller.id}
                        checked={details?.status}
                        onChange={handleSwitchChange(controller.id)}
                        value={controller.id || ''}
                        inputProps={{ 'aria-label': 'controlled' }} 
                      />   
                    } 
                  />
                </ListItem>
              )
            })}
          </Grid> 
          <Grid item sm={4} xs={12}>
            <ListItem className='headingItemNew'>Access Role</ListItem>
            {controllerList?.data?.map((controller) => {
              let selectedRoleIds = controllerRolePermissionsList?.data?.find(per => per?.controller_id === controller.id);
              return (
                <Select
                  disabled={selectedRoleIds?.status === 0 ? true : false}
                  className='selectAccess'
                  fullWidth
                  labelId="demo-simple-select-standard-label"
                  id="access"
                  value={selectedRoleIds?.role_id || []}
                  onChange={(event) => handleAccessSelect(event, controller.id)}
                  multiple
                >
                  {appRolesList?.data.map((permission) => (
                    <MenuItem value={permission.id}>{permission.name}</MenuItem>
                  ))}
                </Select>
              )
            })}
          </Grid>   
      </Grid>
      <Grid style={{ marginTop: 25 }} item xs={12}>
        <Button variant="contained"
          size="small"
          color="primary"
          onClick={handleSaveData}
        > Update </Button>
      </Grid>
    </Box>
    )
  )
}

export default ControllersRoleMapping